/* eslint-disable import/no-anonymous-default-export */
import { Link } from 'react-router-dom';
import { siteConfig } from '../../settings';

export default ({ collapsed }) => {
  return (
    <div className="logoWrapper">
      {collapsed ?
        <Link to="/dashboard">
          <i className={siteConfig.siteIcon} style={{ color: "white" }} />
        </Link>:
        <Link to="/dashboard" style={{ color: "white" }}>{siteConfig.siteName}</Link>
      }
    </div>
  );
};
